import { Button } from '#src/base/button/button.tsx';
import { useClipboard } from '#src/clipboard/use_clipboard.ts';
import { CheckIcon, LinkIcon } from '@phosphor-icons/react';

export interface CopyButtonProps {
  toCopy: string;
  notCopiedLabel: string;
  copiedLabel: string;
  onCopy?: () => void;
}

export const CopyButton = ({ toCopy, notCopiedLabel, copiedLabel, onCopy }: CopyButtonProps) => {
  const { copied, copyToClipboard } = useClipboard({ durationInMs: 2000 });

  return (
    <Button
      variant="primary"
      className="w-full"
      onClick={() => {
        copyToClipboard(toCopy);
        onCopy?.();
      }}
    >
      <span>
        {copied ? (
          <span className="flex items-center">
            <CheckIcon className="mr-2 h-4 w-4" weight="bold" />
            <span>{copiedLabel}</span>
          </span>
        ) : (
          <span className="flex items-center">
            <LinkIcon className="mr-2 h-4 w-4" weight="bold" />
            <span>{notCopiedLabel}</span>
          </span>
        )}
      </span>
    </Button>
  );
};
